<template>
    <div style="background-color: #F2EEEB;">
        <div style="height: 800px;display: flex;align-items: center;justify-content: center;" id="home">
           <div style="padding-top: 30px;">
             <div>
              <img :src="topImage" style="width: 420px;height:528px;"/>
              </div>
              <div style="display: flex;margin-top: 22px;">
                  <div style="width: 50%;">
                    <img :src="iosDownload" style="width: 200px;height:64px;cursor: pointer;" @click="iosdownload"/>
                  </div>
                  <div style="width: 50%;">
                    <img :src="androidDownload" style="width: 200px;height:64px;cursor: pointer;" @click="androiddownload"/>
                  </div>
              </div>
            </div>
        </div>
        <img :src="topwatch" style="width: 100%"/>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: -65px;">
          <img :src="platform" style="width: 1200px;"/>
        </div>
        <div style="margin-top: 80px;" id="product">
          <img :src="productPic" style="width: 100%"/>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: -65px;">
          <div style="width: 1200px;display: flex;align-items: center;justify-content: center;">
            <div style="width: 50%;">
              <img :src="product1" style="width: 580px;"/>
            </div>
            <div style="width: 50%;">
              <img :src="product2" style="width: 580px;" />
            </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 40px;">
          <div style="width: 1200px;display: flex;align-items: center;justify-content: center;">
            <div style="width: 50%;">
              <img :src="product3" style="width: 580px;"/>
            </div>
            <div style="width: 50%;">
              <img :src="product4" style="width: 580px;" />
            </div>
          </div>
        </div>
        <div id="doctor"></div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 100px;">
          <div style="width: 1200px;display: flex;">
            <div style="width: 50%;">
              <div style="width: 85%;">
                  <div style="font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 48px;
                    color: #000000;
                    line-height: 56px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;">
                    医师服务
                  </div>
                  <div style="font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 16px;
                  color: #000000;
                  line-height: 29px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;margin-top: 38px;">
                    “乐活元AI数字健康平台”，提供专业医生团队24小时一对一“健康指导”服务。 </br> </br>  “乐活元”（LOHAS⁺）的专业医生团队，会根据乐活元AI健康手表佩戴者的历史健康数据（心率、血压、血氧饱和度、心电、体脂等）和历史生活数据（运动、睡眠、疲劳度、压力等），帮用户解读其健康数据和生活行为（如膳食、运动、情绪、用药等）之间的关系，解答用户健康疑问及提供个性化的健康指导，帮助用户建立健康的生活方式。
                  </div>
              </div>
            </div>
            <div style="width: 50%;">
              <img :src="doctorPic" style="width: 600px;" />
            </div>
          </div>
        </div>
        <div style="margin-top: 100px;" id="aboutus">
          <img :src="aboutusPic" style="width: 100%"/>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: -65px;">
          <div style="width: 1200px;background: #FFFFFF;border-radius: 40px;" >
            <div style="padding-top: 64px;padding-right: 64px;padding-left: 64px;padding-bottom: 40px;" >
            <div style="font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 48px;
                    color: #000000;
                    line-height: 56px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;">
                    关于我们
                  </div>
                  <div style="font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 16px;
                  color: #000000;
                  line-height: 29px;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;margin-top: 38px;">
                    上海乐活元医学科技有限公司，是一家以“<strong>更健康、更安全、更快乐</strong>”为使命的健康医学新范式科技公司。
                    </br></br>作为数字健康科技行业知名企业，聚焦于准医疗级的AI健康手表产品。其核心优势为：基于穿戴场景的AI健康医学算法及AI应用服务，AI健康软件与智能手表硬件的有机融合。
                    </br></br>其开发的“乐活元AI数字健康平台”通过“乐活元AI健康手表”、移动端APP“乐活元”，对用户健康进行全程、可视化的管理，实现了用户自主监测、系统监护自动预警服务、AI个性化的健康指导、在线医生健康指导、家庭互查共享的生态健康管理。
                    </br></br>“乐活元AI健康手表”，通过高度智能化和精准度的对穿戴者心率、血压，血氧、疲劳度等24小时自动高频次数据采集和趋势动态监测，结合用户发起的一键心电、体脂检测，日监测超2000个生理指标，据此分析数据长期变化趋势，解析用户健康状态。
                    </br></br>“乐活元（LOHAS⁺）”致力于为以心脏健康为主的亚健康群体及乐活族，提供完整的数据驱动、乐活健康服务。帮助用户通过动态监测健康数据，来了解自身健康，及健康生活行为（如膳食、营养、运动、睡眠、情绪、用药等）之间的关系，为用户提供个性化健康指导，和建立健康的生活方式。
                    </br></br>“乐活元AI健康手表”健康数据准、功能多、服务好，让用户更健康、更安全、更快乐！
                  </div>
                  <div style="font-family: PingFang SC, PingFang SC;
                          font-weight: 600;
                          font-size: 32px;
                          color: #CFAD63;
                          line-height: 38px;
                          text-align: left;
                          font-style: normal;
                          text-transform: none;margin-top: 80px;">
                          荣誉资质
                        </div>
            </div>
            <div style="overflow-x: auto;width: 100%;white-space: nowrap;     /* Firefox */
    -ms-overflow-style: none;-webkit-overflow-scrolling: touch; /* 启用原生滚动 */">
              <img :src="ry1" style="width: 169px;" />
              <img :src="ry2" style="width: 130px;margin-left: 36px;" />
              <img :src="ry3" style="width: 140px;margin-left: 36px;" />
              <img :src="ry4" style="width: 171px;margin-left: 36px;" />
              <img :src="ry5" style="width: 135px;margin-left: 36px;" />
              <img :src="ry6" style="width: 135px;margin-left: 36px;" />
              <img :src="ry7" style="width: 135px;margin-left: 36px;" />
              <img :src="ry8" style="width: 135px;margin-left: 36px;" />
              <img :src="ry9" style="width: 135px;margin-left: 36px;" />
              <img :src="ry10" style="width: 135px;margin-left: 36px;" />
              <img :src="ry11" style="width: 135px;margin-left: 36px;" />
              <img :src="ry12" style="width: 135px;margin-left: 36px;" />
              <img :src="ry13" style="width: 135px;margin-left: 36px;" />
              <img :src="ry14" style="width: 135px;margin-left: 36px;" />
              <img :src="ry15" style="width: 135px;margin-left: 36px;" />
              <img :src="ry16" style="width: 135px;margin-left: 36px;" />
            </div>
            <div style="height: 64px;">
              </div>
          </div>
        </div>
        <div style="display: flex;align-items: center;justify-content: center;margin-top: 100px;">
          <div style="width: 1200px;display: flex;align-items: center;justify-content: center;">
            <div style="width: 50%;">
              <img :src="contacts" style="width: 560px;" />
            </div>
            <div style="width: 50%;">
              <div>
                  <div style="font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 48px;
                    color: #CFAD63;
                    line-height: 56px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;">
                    联系我们
                  </div>
                  <div style="font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #000000;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;margin-top: 32px;">
                    上海市浦东新区源深路655号 ISPACE 乐活元
                  </div>
                  <div style="font-family: PingFang SC, PingFang SC;
                    font-weight: 600;
                    font-size: 16px;
                    color: #000000;
                    line-height: 22px;
                    text-align: left;
                    font-style: normal;
                    text-transform: none;margin-top: 32px;">
                    邮箱：lehuoyuan@ai-wanjia.com
                  </div>
              </div>
            </div>
          </div>
        </div>
        <div style="height: 80px;">
        </div>
        <div style="height:292px;background-color: #000000;">
          <div style="height:212px;display: flex;">
            <div style="width: 70%;">
              <div style="width: 100px;margin-left: 120px;padding-top: 40px;">
                <img :src="logoBottom" style="width:100px;"/>
              </div>
            </div>
            <div style="width: 30%;display: flex;">
              <div style="width: 120px;padding-top: 40px;">
                <img :src="logoDownload" style="width:120px;"/>
                <div style="margin-top: 4px;
                height: 24px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 14px;
                color: #B9B3AF;
                line-height: 24px;
                text-align: center;
                font-style: normal;
                text-transform: none;">乐活元APP</div>
              </div>
              <div style="width: 120px;margin-left: 32px;padding-top: 40px;">
                <img :src="logoWx" style="width:120px;"/>
                <div style="margin-top: 4px;
                height: 24px;
                font-family: PingFang SC, PingFang SC;
                font-weight: 600;
                font-size: 14px;
                color: #B9B3AF;
                line-height: 24px;
                text-align: center;
                font-style: normal;
                text-transform: none;">乐活元公众号</div>
              </div>
            </div>
          </div>
          <div style="border: 1px solid #B9B3AF;opacity: 0.6;">
          </div>
          <div  style="height:80px;display: flex;align-items: center;justify-content: center;">
            <img :src="gawbPic" style="width:15px;"/> &nbsp;&nbsp;<a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31011502403108" title="公安网备" style='color:white'>沪公网安备31011502403108号</a>&nbsp;&nbsp; Copyright &copy; 2023  版权所有   &nbsp;&nbsp; <a href="http://beian.miit.gov.cn/" title="ICP备案" style='color:white'>沪ICP备2023012114号-4</a>
          </div>
        </div>
    </div>

</template>

<script>

export default {
    data() {
        return {
          topImage: require('../../assets/website/top-image.png'),
          androidDownload: require('../../assets/website/android-download.png'),
          iosDownload: require('../../assets/website/ios-download.png'),
          topwatch: require('../../assets/website/topwatch.png'),
          platform: require('../../assets/website/platform.png'),
          productPic: require('../../assets/website/product.png'),
          product1: require('../../assets/website/product1.png'),
          product2: require('../../assets/website/product2.png'),
          product3: require('../../assets/website/product3.png'),
          product4: require('../../assets/website/product4.png'),
          doctorPic: require('../../assets/website/doctor.png'),
          aboutusPic: require('../../assets/website/aboutus.png'),
          contacts: require('../../assets/website/contacts.png'),
          logoBottom: require("../../assets/website/logo-bottom.png"),
            logoDownload: require("../../assets/website/lohas-download.png"),
            logoWx: require("../../assets/website/lohas-wx.jpg"),
          gawbPic: require("../../assets/images/gawb.png"),
          ry1: require("../../assets/website/ry1.png"),
          ry2: require("../../assets/website/ry2.png"),
          ry3: require("../../assets/website/ry3.png"),
          ry4: require("../../assets/website/ry4.png"),
          ry5: require("../../assets/website/ry5.jpg"),
          ry6: require("../../assets/website/ry6.jpg"),
          ry7: require("../../assets/website/ry7.jpg"),
          ry8: require("../../assets/website/ry8.jpg"),
          ry9: require("../../assets/website/ry9.jpg"),
          ry10: require("../../assets/website/ry10.jpg"),
          ry11: require("../../assets/website/ry11.jpg"),
          ry12: require("../../assets/website/ry12.jpg"),
          ry13: require("../../assets/website/ry13.jpg"),
          ry14: require("../../assets/website/ry14.jpg"),
          ry15: require("../../assets/website/ry15.jpg"),
          ry16: require("../../assets/website/ry16.jpg"),
        }
    },
    components: {
    },
    methods: {
      iosdownload() {
        window.open('https://apps.apple.com/us/app/%E4%B9%90%E6%B4%BB%E5%85%83/id6464010298')
      },
      androiddownload() {
        window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.ai.lehuoyuan')
      },
    }
}
</script>
<style lang="less" rel="stylesheet/less" scoped>
.scroll-div::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
}

.scroll-div {
    scrollbar-width: none; /* Firefox */
    -ms-overflow-style: none;  /* IE and Edge */
    overflow: auto; /* 允许滚动 */
    white-space: nowrap; /* 防止内容换行 */
}
</style>



// WEBPACK FOOTER //
// src/page/index/index.vue